import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Medal, Check, Lock, Coins } from "lucide-react";

export function AchievementsPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/api/game/achievements").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="p-6 text-stone-500 italic">Loading achievements…</div>;

  return (
    <div className="p-4 lg:p-6 space-y-6" data-testid="achievements-panel">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <div>
          <h2 className="font-display text-3xl heading-gilded mb-1">Achievements</h2>
          <p className="text-stone-500 font-body">
            Milestones your saga has crossed. Completing one auto-deposits a small gold reward.
          </p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-numeric text-amber-300" data-testid="ach-count">
            {data.unlocked} / {data.total}
          </div>
          <div className="text-[10px] uppercase tracking-widest font-numeric text-stone-500">
            {Math.round((data.unlocked / data.total) * 100)}% completed
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {data.achievements.map((a) => {
          const pct = Math.min(100, Math.round((a.current / a.target) * 100));
          return (
            <article
              key={a.id}
              className={"panel p-4 flex gap-3 " + (a.unlocked ? "border-emerald-700/70" : "")}
              data-testid={`ach-${a.id}`}
            >
              <div
                className={
                  "w-11 h-11 rounded-full flex items-center justify-center border " +
                  (a.unlocked ? "bg-emerald-900/40 border-emerald-500 text-emerald-300"
                    : "bg-stone-900 border-stone-700 text-stone-500")
                }
              >
                {a.unlocked ? <Check size={20} /> : <Medal size={20} />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <div className="font-display text-base leading-tight">{a.name}</div>
                  <div className="flex items-center gap-1 text-xs font-numeric text-amber-400">
                    <Coins size={10} /> {a.reward_gold}
                  </div>
                </div>
                <div className="text-xs text-stone-400 font-body">{a.desc}</div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="xp-bar-outer flex-1"><div className="xp-bar-fill" style={{ width: `${pct}%` }} /></div>
                  <div className="text-[10px] font-numeric text-stone-500">{a.current}/{a.target}</div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
